import { render, staticRenderFns } from "./MyTasks.vue?vue&type=template&id=08c2cbe8&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./MyTasks.vue?vue&type=style&index=0&id=08c2cbe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c2cbe8",
  null
  
)

export default component.exports